import { render } from "./contact-view.vue?vue&type=template&id=ce5dece4"
import script from "./contact-view.vue?vue&type=script&lang=js"
export * from "./contact-view.vue?vue&type=script&lang=js"

import "./contact-view.vue?vue&type=style&index=0&id=ce5dece4&lang=scss"

import exportComponent from "C:\\www\\momentum_v2\\momentum\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__